import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";

export default function DeactivatedPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 px-4">
      <div className="max-w-md w-full text-center bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-10">
        <div className="w-20 h-20 mx-auto mb-6 bg-red-100 dark:bg-red-900/30 rounded-full flex items-center justify-center">
          <Icon
            icon="mdi:account-cancel-outline"
            className="w-10 h-10 text-red-600 dark:text-red-400"
          />
        </div>
        <h1 className="text-2xl font-semibold text-gray-900 dark:text-white">
          Account Deactivated
        </h1>
        <p className="mt-3 text-sm text-gray-600 dark:text-gray-300">
          Your account has been deactivated. Please contact your administrator to restore access.
        </p>
        <a
          href="mailto:support@osmoair.com"
          className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-primary text-white text-sm font-medium hover:bg-primary/90 transition-colors"
        >
          <Icon icon="mdi:email-outline" className="w-4 h-4" />
          Contact support@osmoair.com
        </a>
        <div className="mt-4">
          <Link
            to="/login"
            className="text-sm text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 underline"
          >
            Back to login
          </Link>
        </div>
      </div>
    </div>
  );
}
